import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { Logo } from "./Logo";
import { waLink, DEFAULT_WA_TEXT } from "../../lib/constants";
import { track } from "../../lib/tracking";

const links = [
  { label: "The Offer", href: "#package" },
  { label: "Journey", href: "#journey" },
  { label: "FAQ", href: "#faq" },
];

export const Navbar = ({ onBook }) => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,box-shadow,border-color] duration-500 border-b ${
        scrolled ? "bg-ivory/90 backdrop-blur-xl border-champagne/50 shadow-[0_8px_30px_rgba(26,29,32,0.05)]" : "bg-transparent border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10 h-[72px] flex items-center justify-between">
        <Logo />
        <nav className="hidden md:flex items-center gap-8" aria-label="Primary">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-xs font-semibold uppercase tracking-[0.18em] text-ink/60 hover:text-teal transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a
            href={waLink(DEFAULT_WA_TEXT)}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => track("whatsapp_click", { placement: "navbar" })}
            data-testid="nav-whatsapp-button"
            className="hidden sm:inline-flex items-center gap-2 rounded-full border border-teal/30 px-5 py-2.5 text-xs font-bold uppercase tracking-[0.14em] text-teal hover:bg-teal hover:text-ivory transition-colors duration-300"
          >
            <MessageCircle className="w-4 h-4" strokeWidth={1.8} />
            WhatsApp
          </a>
          <button
            onClick={onBook}
            data-testid="nav-book-button"
            className="inline-flex items-center rounded-full bg-teal px-5 py-2.5 text-xs font-bold uppercase tracking-[0.14em] text-ivory hover:bg-teal-800 transition-colors duration-300"
          >
            Book
          </button>
        </div>
      </div>
    </header>
  );
};
